import React, { useContext, useState, useEffect } from 'react'
import { dateTimeFormatFunction, capitalize } from '../../../common/components'
import { currencyFormat } from '@/custom/common/components'
import { Button } from '@mui/material'
import CartItem from '@/views/Invoice/cartItem'
import { LOGO, SITE_NAME } from '@/utils/UI/index'
import bwipjs from 'bwip-js'

const CommonInvoiceView = (props) => {
    const ref = React.createRef()
    const t = (text) => {
        text = text.charAt(0).toUpperCase() + text.slice(1)
        return text.replace(/_/g, ' ')
    }
    const [printId, setPrintId] = useState({ id: '0' })
    const [print, setPrint] = useState(false)
    const [lastElement, setLastElement] = useState({})

    let [invoiceDetails, setInvoiceDetails] = useState({
        invoiceProducts: [],
        cartValues: {},
        appointmentDetail: {},
        locationDetail: {},
        invoiceTransactions: [],
        invoiceUser: [],
        invoiceAddress: [],
        orderControlLogs: [],
    })

    useEffect(() => {
        setInvoiceDetails({
            invoiceProducts: [],
            cartValues: {},
            appointmentDetail: {},
            locationDetail: {},
            invoiceTransactions: [],
            invoiceUser: [],
            invoiceAddress: [],
            orderControlLogs: [],
        })
        return () => {
            setInvoiceDetails({
                invoiceProducts: [],
                cartValues: {},
                appointmentDetail: {},
                locationDetail: {},
                invoiceTransactions: [],
                invoiceUser: [],
                invoiceAddress: [],
                orderControlLogs: [],
            })
        }
    }, [])

    useEffect(() => {
        if (
            Object.keys(props.invoiceDetails).length &&
            props.status === 'print'
        ) {
            setInvoiceDetails({
                invoiceProducts: props.invoiceDetails.invoiceItems.length
                    ? props.invoiceDetails.invoiceItems
                    : [],
                cartValues: props.invoiceDetails.cartValues,
                appointmentDetail: props.invoiceDetails.appointmentrecord,
                invoiceUser: props.invoiceDetails.invoiceUser,
                invoiceAddress: props.invoiceDetails.invoiceAddress,
                locationDetail: {},
                invoiceTransactions: [],
                orderControlLogs: props?.invoiceDetails?.order_control_logs,
            })
            if (props.invoiceDetails.invoiceItems.length) {
                let arry = props.invoiceDetails.invoiceItems
                let lastEle = arry[arry.length - 1]
                setLastElement(lastEle)
            }
        } else if (
            Object.keys(props.invoiceDetails).length &&
            props.status === 'multi_view'
        ) {
            setInvoiceDetails({
                invoiceProducts: props.invoiceDetails.invoiceItems.length
                    ? props.invoiceDetails.invoiceItems
                    : [],
                cartValues: props.invoiceDetails.cartValues,
                appointmentDetail: props.invoiceDetails.appointmentrecord,
                invoiceUser: props.invoiceDetails.invoiceUser,
                invoiceAddress: props.invoiceDetails.invoiceAddress,
                locationDetail: {},
                invoiceTransactions: [],
                orderControlLogs: props?.invoiceDetails?.order_control_logs,
            })
        } else if (
            Object.keys(props.invoiceDetails).length &&
            props.status === 'view'
        ) {
            setInvoiceDetails({
                invoiceProducts: props.invoiceDetails.invoicerecords.length
                    ? props.invoiceDetails.invoicerecords
                    : [],
                cartValues: props.invoiceDetails.cartvalues,
                appointmentDetail: props.invoiceDetails.appointmentrecord,
                locationDetail: props.invoiceDetails.locationrecord,
                invoiceTransactions: props.invoiceDetails.transactionrecords,
                invoiceUser: props.invoiceDetails.invoiceuserrecord,
                invoiceAddress: props.invoiceDetails.invoiceaddressrecord,
                orderControlLogs: props?.invoiceDetails?.order_control_logs,
            })
        } else {
            setInvoiceDetails({
                invoiceProducts: [],
                cartValues: {},
                appointmentDetail: {},
                locationDetail: {},
                invoiceTransactions: [],
                invoiceUser: [],
                invoiceAddress: [],
                orderControlLogs: [],
            })
        }
    }, [props.invoiceDetails, props.status])

    useEffect(() => {
        if (
            invoiceDetails.cartValues &&
            invoiceDetails.cartValues?.common_invoice
        ) {
            try {
                if (invoiceDetails.cartValues?.common_invoice) {
                    let canvas = bwipjs.toCanvas(
                        `${invoiceDetails.cartValues?.common_invoice}`,
                        {
                            bcid: 'code128',
                            text: invoiceDetails.cartValues?.common_invoice.toString(),
                            // scale: 8,
                            width: 50,
                            height: 15,
                            includetext: true,
                            textxalign: 'center',
                        }
                    )
                }
            } catch (e) {}
        }
    }, [invoiceDetails])

    const getProductTitle = (id) => {
        let products = invoiceDetails.invoiceProducts
        let productTitle =
            products.filter((item) => item.project_id === id)[0]
                ?.projects_title || ''
        return productTitle
    }

    return (
        <>
            <div className="container-lg productInvoice">
                <h3 className="invoiceTitle">TAX INVOICE </h3>
                <div className="d-flex justify-content-end align-items-center mb-2 noPrint">
                    {/* <Breadcrumbs aria-label="breadcrumb" className="naBreadcrumbs">
                        <Link to="/dashboard/won">Dashboard</Link>
                        <Typography color="textPrimary">Invoice</Typography>
                    </Breadcrumbs> */}
                    <Button id="invoice_print" onClick={() => window.print()}>
                        <span className="material-icons">print</span>
                        {'Print'}
                    </Button>
                </div>
                <div
                    className={`invoiceView ${
                        props.print ? 'invoiceViewPrint' : ''
                    }`}
                    ref={ref}
                    style={{ height: '100%', width: '100%' }}
                >
                    <div className="card-header d-flex justify-content-between align-items-center p-4">
                        <a className="pt-2 d-inline-block" data-abc="true">
                            <img
                                src={LOGO}
                                className="invLogo"
                                alt={SITE_NAME}
                                style={{ width: '160px' }}
                            />
                        </a>
                        <canvas
                            id={invoiceDetails.cartValues.common_invoice}
                        ></canvas>

                        <div className="float-right invDate">
                            <h5 className="mb-0">
                                {t('invoice')} #
                                {invoiceDetails.cartValues.common_invoice}{' '}
                            </h5>
                            <h5 className="mb-0">
                                {t('date')}:{' '}
                                {invoiceDetails.invoiceProducts[0]?.active === 2
                                    ? dateTimeFormatFunction(
                                          invoiceDetails.invoiceProducts[0]
                                              ?.returned_date
                                      )
                                    : dateTimeFormatFunction(
                                          invoiceDetails.cartValues
                                              .cart_paiddate
                                      )}
                            </h5>
                            <h5 className="mb-0">
                                {t('status')}:{' '}
                                {invoiceDetails.invoiceProducts[0]?.active === 2
                                    ? 'Cancelled'
                                    : invoiceDetails.cartValues.cart_paid
                                      ? 'Paid'
                                      : 'Unpaid'}
                            </h5>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row mb-4">
                            <div className="col-sm-6 invAddr">
                                <h5 className="mb-3">{t('from')}:</h5>
                                <h3 className="text-dark mb-1">{'Box Bids'}</h3>
                                <div>{'129 W Butler Road'}</div>
                                <div>
                                    {'Mauldin'} {'SC'} {'29662'}
                                </div>

                                <div>1 (864) 300-BIDS</div>
                            </div>
                            {invoiceDetails.invoiceUser?.length ? (
                                <div className="col-sm-6 invAddr text-right">
                                    <h5 className="mb-3">To:</h5>
                                    <h3 className="text-dark mb-1">
                                        {
                                            invoiceDetails.invoiceUser[0]
                                                .first_name
                                        }{' '}
                                        {
                                            invoiceDetails.invoiceUser[0]
                                                .last_name
                                        }
                                    </h3>
                                    {invoiceDetails.invoiceAddress.length ? (
                                        <>
                                            <div>
                                                {
                                                    invoiceDetails
                                                        ?.invoiceAddress[0]
                                                        ?.address1
                                                }
                                            </div>
                                            <div>
                                                {
                                                    invoiceDetails
                                                        ?.invoiceAddress[0]
                                                        ?.address2
                                                }
                                            </div>
                                            {invoiceDetails.invoiceAddress[0]
                                                .city &&
                                                invoiceDetails.invoiceAddress[0]
                                                    .state &&
                                                invoiceDetails.invoiceAddress[0]
                                                    .country && (
                                                    <div>
                                                        {
                                                            invoiceDetails
                                                                .invoiceAddress[0]
                                                                .city
                                                        }
                                                        ,{' '}
                                                        {
                                                            invoiceDetails
                                                                .invoiceAddress[0]
                                                                .state
                                                        }
                                                        ,{' '}
                                                        {
                                                            invoiceDetails
                                                                .invoiceAddress[0]
                                                                .country
                                                        }{' '}
                                                        -{' '}
                                                        {
                                                            invoiceDetails
                                                                .invoiceAddress[0]
                                                                .zip
                                                        }
                                                    </div>
                                                )}
                                        </>
                                    ) : (
                                        <>
                                            <div>
                                                {
                                                    invoiceDetails
                                                        ?.invoiceUser[0]
                                                        ?.address1
                                                }
                                            </div>
                                            <div>
                                                {
                                                    invoiceDetails
                                                        ?.invoiceUser[0]
                                                        ?.address2
                                                }
                                            </div>
                                            {invoiceDetails.invoiceUser[0]
                                                .city &&
                                                invoiceDetails.invoiceUser[0]
                                                    .state &&
                                                invoiceDetails.invoiceUser[0]
                                                    .country && (
                                                    <div>
                                                        {
                                                            invoiceDetails
                                                                .invoiceUser[0]
                                                                .city
                                                        }
                                                        ,{' '}
                                                        {
                                                            invoiceDetails
                                                                .invoiceUser[0]
                                                                .state
                                                        }
                                                        ,{' '}
                                                        {
                                                            invoiceDetails
                                                                .invoiceUser[0]
                                                                .country
                                                        }{' '}
                                                        -{' '}
                                                        {
                                                            invoiceDetails
                                                                .invoiceUser[0]
                                                                .zip
                                                        }
                                                    </div>
                                                )}
                                        </>
                                    )}

                                    <div>
                                        Email:{' '}
                                        {invoiceDetails.invoiceUser[0].email}
                                    </div>
                                    <div>
                                        Phone:{' '}
                                        {invoiceDetails.invoiceUser[0].phone}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        {/* {invoiceDetails.cartValues.cart_payment ? (
                        <>
                            <h4 className="invoiceSubTitle">
                                Payment Type:{' '}
                                {invoiceDetails.cartValues.cart_payment === 'online' ? (
                                    <>{t('online_payment')}</>
                                ) : invoiceDetails.cartValues.cart_payment === 'offline' ? (
                                    <>{t('offline_payment')}</>
                                ) : invoiceDetails.cartValues.cart_payment === 'deposit' ? (
                                    <>{t('deposit')}</>
                                ) : null}
                            </h4>
                        </>
                    ) : null} */}
                        {/* {invoiceDetails.appointmentDetail ? (
                            <>
                                <h4 className="invoiceSubTitle">
                                    {t('appointment_scheduled_at')}:{' '}
                                    {dateTimeFormatFunction(
                                        invoiceDetails.appointmentDetail.appointmentTime,
                                    )}
                                </h4>
                            </>
                        ) : null} */}
                        {invoiceDetails.invoiceProducts[0]?.active === 2 ? (
                            <>
                                <h4 className="invoiceSubTitle text-danger">
                                    {'Invoice Cancelled: '}
                                    {invoiceDetails.invoiceProducts[0]?.notes}
                                </h4>
                            </>
                        ) : null}
                        {invoiceDetails.invoiceTransactions.length ? (
                            <>
                                <h4 className="invoiceSubTitle">
                                    {t('transaction_details')}
                                </h4>
                                <div className="transDet d-flex justify-content-between flex-wrap">
                                    <>
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    {/* <th scope="col">S.No</th> */}
                                                    <th scope="col">
                                                        {t('transaction_id')}
                                                    </th>
                                                    <th scope="col">
                                                        {t('paid_on')}
                                                    </th>
                                                    <th scope="col">
                                                        {t('method')}
                                                    </th>
                                                    <th scope="col">
                                                        {t('amount')}
                                                    </th>
                                                    <th scope="col">
                                                        {t('status')}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {invoiceDetails.invoiceTransactions.map(
                                                    (data, index) => (
                                                        <tr key={index}>
                                                            <td
                                                                data-title={t(
                                                                    'transaction_id'
                                                                )}
                                                            >
                                                                {data.trans_id
                                                                    ? `# ${data.trans_id}`
                                                                    : '-'}
                                                            </td>
                                                            <td
                                                                data-title={t(
                                                                    'paid_on'
                                                                )}
                                                            >
                                                                {dateTimeFormatFunction(
                                                                    data.created_at
                                                                )}
                                                            </td>
                                                            <td
                                                                data-title={t(
                                                                    'card'
                                                                )}
                                                            >
                                                                {data.payment_method ===
                                                                'cash' ? (
                                                                    <>
                                                                        {t(
                                                                            'cash'
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        {/* {data.mk_card_number} (
                                                                    {data.card_type}) */}
                                                                        {capitalize(
                                                                            data.payment_method
                                                                            // t,
                                                                        )}
                                                                    </>
                                                                )}
                                                            </td>
                                                            <td
                                                                data-title={t(
                                                                    'amount'
                                                                )}
                                                            >
                                                                {currencyFormat(
                                                                    data.amount
                                                                )}
                                                            </td>
                                                            <td
                                                                data-title={t(
                                                                    'payment_status'
                                                                )}
                                                                style={{
                                                                    color:
                                                                        data.status ===
                                                                        'success'
                                                                            ? 'green'
                                                                            : 'red',
                                                                }}
                                                            >
                                                                {capitalize(
                                                                    data.status
                                                                )}
                                                            </td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    </>
                                </div>
                            </>
                        ) : null}
                        <h4 className="invoiceSubTitle mt-5">
                            {t('product_details')}
                        </h4>

                        <div className="table-responsive">
                            {invoiceDetails.invoiceProducts.length ? (
                                <div className="cartProducts">
                                    <div>
                                        {invoiceDetails.invoiceProducts.map(
                                            (data, index) => (
                                                <CartItem
                                                    data={data}
                                                    from="invoice"
                                                    showLocation={true}
                                                    showInventory={true}
                                                    updateFunction={
                                                        props.updateFunction
                                                    }
                                                    productUpdate={lastElement}
                                                />
                                            )
                                        )}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        <div className="row mt-5">
                            <div className="col-12">
                                <div className="table-responsive">
                                    <table className="table table-clear nellisInvTot">
                                        <tbody>
                                            <tr>
                                                <td
                                                    className="left"
                                                    align="right"
                                                >
                                                    <span className="text-dark">
                                                        {t('items')}
                                                    </span>
                                                </td>
                                                <td className="right">
                                                    <span className="text-dark">
                                                        {
                                                            invoiceDetails
                                                                .invoiceProducts
                                                                .length
                                                        }
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    className="left"
                                                    align="right"
                                                >
                                                    <span className="text-dark">
                                                        {t('subtotal')}
                                                    </span>
                                                </td>
                                                <td className="right">
                                                    <span className="text-dark">
                                                        {currencyFormat(
                                                            invoiceDetails
                                                                .cartValues
                                                                .per_total
                                                        )}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    className="left"
                                                    align="right"
                                                >
                                                    <span className="text-dark">
                                                        {props.taxLabel
                                                            ? props.taxLabel
                                                            : t('VAT')}
                                                        {invoiceDetails
                                                            .invoiceProducts
                                                            .length ? (
                                                            <>
                                                                {' '}
                                                                (
                                                                {
                                                                    invoiceDetails
                                                                        .invoiceProducts[0]
                                                                        .tax_percent
                                                                }
                                                                %)
                                                            </>
                                                        ) : null}
                                                    </span>
                                                </td>

                                                <td className="right">
                                                    <span className="text-dark">
                                                        {currencyFormat(
                                                            invoiceDetails
                                                                .cartValues
                                                                .total_tax
                                                        )}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    className="left"
                                                    align="right"
                                                >
                                                    <span className="text-dark">
                                                        {t("Buyer's Premium")}
                                                        {invoiceDetails
                                                            .invoiceProducts
                                                            .length ? (
                                                            <>
                                                                {' '}
                                                                (
                                                                {
                                                                    invoiceDetails
                                                                        .invoiceProducts[0]
                                                                        .buyer_premium_percent
                                                                }
                                                                %)
                                                            </>
                                                        ) : null}
                                                    </span>
                                                </td>

                                                <td className="right">
                                                    <span className="text-dark">
                                                        {currencyFormat(
                                                            invoiceDetails
                                                                .cartValues
                                                                .total_premium
                                                        )}
                                                    </span>
                                                </td>
                                            </tr>
                                            {invoiceDetails.cartValues
                                                .total_shipping ? (
                                                <tr>
                                                    <td
                                                        className="left"
                                                        align="right"
                                                    >
                                                        <span className="text-dark">
                                                            {t('Shipping')}
                                                        </span>
                                                    </td>
                                                    <td className="right">
                                                        <span className="text-dark">
                                                            {currencyFormat(
                                                                invoiceDetails
                                                                    .cartValues
                                                                    .total_shipping
                                                            )}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ) : null}

                                            {invoiceDetails?.cartValues
                                                ?.transfer_fee ? (
                                                <tr>
                                                    <td
                                                        className="left"
                                                        align="right"
                                                    >
                                                        <span className="text-dark">
                                                            {t('Transfer Fee')}
                                                        </span>
                                                    </td>
                                                    <td className="right">
                                                        <span className="text-dark">
                                                            {currencyFormat(
                                                                invoiceDetails
                                                                    .cartValues
                                                                    .transfer_fee
                                                            )}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ) : null}

                                            {invoiceDetails?.cartValues
                                                ?.box_assurance_fee ? (
                                                <tr>
                                                    <td
                                                        className="left"
                                                        align="right"
                                                    >
                                                        <span className="text-dark">
                                                            {t(
                                                                'Box Assurance Fee'
                                                            )}
                                                        </span>
                                                    </td>
                                                    <td className="right">
                                                        <span className="text-dark">
                                                            {currencyFormat(
                                                                invoiceDetails
                                                                    .cartValues
                                                                    .box_assurance_fee
                                                            )}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ) : null}

                                            {invoiceDetails?.cartValues
                                                ?.item_fee ? (
                                                <tr>
                                                    <td
                                                        className="left"
                                                        align="right"
                                                    >
                                                        <span className="text-dark">
                                                            {t('Lot Fee')}
                                                        </span>
                                                    </td>
                                                    <td className="right">
                                                        <span className="text-dark">
                                                            {currencyFormat(
                                                                invoiceDetails
                                                                    .cartValues
                                                                    .item_fee
                                                            )}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ) : null}

                                            <tr>
                                                <td
                                                    className="left"
                                                    align="right"
                                                >
                                                    <span className="text-dark">
                                                        {t('total_amount')}
                                                    </span>
                                                </td>
                                                <td className="right">
                                                    <span className="text-dark">
                                                        {currencyFormat(
                                                            invoiceDetails
                                                                .cartValues
                                                                .total_amount
                                                        )}
                                                    </span>
                                                </td>
                                            </tr>
                                            {invoiceDetails.cartValues
                                                .total_deposit ? (
                                                <tr>
                                                    <td
                                                        className="left"
                                                        align="right"
                                                    >
                                                        <span className="text-dark">
                                                            {t('bid_deposit')}
                                                        </span>
                                                    </td>
                                                    <td className="right">
                                                        <span className="text-dark">
                                                            -{' '}
                                                            {currencyFormat(
                                                                invoiceDetails
                                                                    .cartValues
                                                                    .total_deposit
                                                            )}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ) : null}

                                            {invoiceDetails.cartValues
                                                .total_paid ? (
                                                <tr>
                                                    <td
                                                        className="left"
                                                        align="right"
                                                    >
                                                        <span className="text-dark">
                                                            {t('total_paid')}
                                                        </span>
                                                    </td>
                                                    <td className="right">
                                                        <span className="text-dark">
                                                            {currencyFormat(
                                                                invoiceDetails
                                                                    .cartValues
                                                                    .total_paid
                                                            )}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ) : null}

                                            {invoiceDetails.cartValues
                                                .total_due_amount ? (
                                                <tr>
                                                    <td
                                                        className="left"
                                                        align="right"
                                                    >
                                                        <span className="text-dark">
                                                            {t(
                                                                'pending_amount'
                                                            )}
                                                        </span>
                                                    </td>
                                                    <td className="right">
                                                        <span className="text-dark">
                                                            {currencyFormat(
                                                                invoiceDetails
                                                                    .cartValues
                                                                    .total_due_amount
                                                            )}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ) : null}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {props?.orderControlLogs &&
                invoiceDetails?.orderControlLogs?.length ? (
                    <>
                        <br></br>
                        <h4>Order Control Logs</h4>

                        <div>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        {/* <th scope="col">Id</th> */}
                                        <th scope="col">Product Title</th>
                                        <th scope="col">Order Status</th>
                                        <th scope="col">Date/Time</th>
                                        <th scope="col">Employee name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {invoiceDetails.orderControlLogs
                                        .filter(
                                            (item) => item.order_status !== '5'
                                        )
                                        .map((item, index) => (
                                            <tr key={index}>
                                                {/* <td>{item.project_id}</td> */}
                                                <td>
                                                    {getProductTitle(
                                                        item.project_id
                                                    )}
                                                </td>
                                                <td>
                                                    {item.order_status === '1'
                                                        ? 'In Transit'
                                                        : item.order_status ===
                                                            '2'
                                                          ? 'Ready for Pickup'
                                                          : item.order_status ===
                                                              '3'
                                                            ? 'Delivered'
                                                            : item.order_status ===
                                                                '4'
                                                              ? 'Cancelled'
                                                              : 'Unknown'}
                                                </td>
                                                <td>
                                                    {dateTimeFormatFunction(
                                                        item.created_at
                                                    )}
                                                </td>
                                                <td>{`${item.as_employees_emp_firstname} ${item.as_employees_emp_lastname}`}</td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                        <br></br>
                    </>
                ) : null}

                <h4 className="thankText">
                    {t('thank_you_for_shopping_with_us')}
                </h4>
            </div>
        </>
    )
}

export default CommonInvoiceView
